<template>
  <div v-if="showAlert" class="alert alert-warning alert-dismissible fade show" role="alert">

    <slot>
      default alert value
    </slot>
    <button @click="closeAlert" type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>


<script>
export default {
  name: 'Alert1',
  data() {
    return {
      showAlert: false, // وضعیت نمایش پیام
    };
  },
  methods: {
    // بررسی وضعیت Local Storage برای نمایش پیام
    checkLocalStorage() {
      const alertClosed = localStorage.getItem("alertClosed");

      // اگر کاربر قبلاً پیام را بسته یا قبلاً بازدید کرده است، پیام نمایش داده نشود
      if (!alertClosed) {
        this.showAlert = true; // نمایش پیام برای اولین بازدید
      }
    },

    // بستن پیام و ذخیره وضعیت در Local Storage
    closeAlert() {
      this.showAlert = false;                        // مخفی کردن پیام
      localStorage.setItem("alertClosed", "true");   // ذخیره وضعیت بستن پیام
    },
  },
  mounted() {
    this.checkLocalStorage(); // بررسی Local Storage هنگام بارگذاری کامپوننت
  },
}

</script>


<style scoped>

</style>